import {createRouter, createWebHistory} from 'vue-router';

/********* Trabaja en Agrovision - Vistas Postulante ********/
import Inicio from '@/views/frontend/pages/trabaja_en_agv/inicio.vue'
import EscuelaCorporativa from '@/views/frontend/pages/trabaja_en_agv/escuela_corp.vue'
import OfertasLaborales from '@/views/frontend/pages/trabaja_en_agv/ofertas_lab.vue'
import DetalleOfertaLaboral from '@/views/frontend/pages/trabaja_en_agv/detalle_oferta_lab.vue'
// import CrearCuenta from '@/views/frontend/pages/trabaja_en_agv/crear_cuenta.vue'
import YoungTalent from '@/views/frontend/pages/trabaja_en_agv/young_talent.vue'
import Nosotros from '@/views/frontend/pages/trabaja_en_agv/nosotros.vue'
//import CrearCuenta from '@/views/frontend/pages/trabaja_en_agv/crear_cuenta_all.vue'
import CrearCuenta2 from '@/views/frontend/pages/trabaja_en_agv/crear_cuenta.vue'
import PostulacionCorrecta from '@/views/frontend/pages/trabaja_en_agv/postulacion_correcta.vue'

import NuestraCultura from '@/views/frontend/pages/trabaja_en_agv/nuestra_cultura.vue'

import DashboardPostulanteOfertasLaborales from '@/views/frontend/pages/trabaja_en_agv/dashboard_postulante/ofertas_laborales.vue'
import DashboardPostulanteDetalleOferta from '@/views/frontend/pages/trabaja_en_agv/dashboard_postulante/detalle_oferta.vue'
import DashboardPostulaciones from '@/views/frontend/pages/trabaja_en_agv/dashboard_postulante/postulaciones.vue'
import DashboardFavoritos from '@/views/frontend/pages/trabaja_en_agv/dashboard_postulante/favoritos.vue'
import DashboardPostulanteAccesosSistema from '@/views/frontend/pages/trabaja_en_agv/dashboard_postulante_accesos_sistema.vue'
import DashboardPostulanteDatosPersonales from '@/views/frontend/pages/trabaja_en_agv/dashboard_postulante/perfil.vue'
import DashboardPostulanteEducacion from '@/views/frontend/pages/trabaja_en_agv/dashboard_postulante_educacion_exp_lab.vue'
// import DashboardPostulanteExperienciaLaboral from '@/views/frontend/pages/trabaja_en_agv/dashboard_postulante_accesos_sistema.vue'

import NuestrosColaboradores from '@/views/frontend/pages/trabaja_en_agv/nuestros_colaboradores.vue'
import CrearCuenta from '@/views/frontend/pages/trabaja_en_agv/crear_cuenta/registro.vue'
// import AcercaDe from '@/views/frontend/pages/trabaja_en_agv/acerca_de.vue'
// import ProgramaYoungTalent from '@/views/frontend/pages/trabaja_en_agv/pyoung_talent.vue'
// import NuestrosColaboradores from '@/views/frontend/pages/trabaja_en_agv/nuestros_colab.vue'
// import TrabajaConNosotros from '@/views/frontend/pages/trabaja_en_agv/trabaja_nosotros.vue'
// import IniciarSesion from '@/views/frontend/pages/trabaja_en_agv/iniciar_sesion.vue'

//*********** Vista No Disponible para módulos no habilitados ********** //
import NoDisponible from '@/views/NoDisponible.vue'


/**************** Frontend  *************/
import Login from '@/views/frontend/pages/trabaja_en_agv/login.vue'
import Home from '@/views/frontend/pages/index/home.vue'
import Index from '@/views/frontend/pages/index/home/index.vue'
import Indextwo from '@/views/frontend/pages/index/home2/index-two.vue'
import Indexthree from '@/views/frontend/pages/index/home3/index-three.vue'
import IndexFour from '@/views/frontend/pages/index/home4/index-four.vue'
import IndexFive from '@/views/frontend/pages/index/home5/index-five.vue'
import Employers from '@/views/frontend/pages/employers/employers.vue'
import ManageProject from '@/views/frontend/pages/employers/project/manage-projects.vue'
import OngoingProjects from '@/views/frontend/pages/employers/project/ongoing-projects.vue'
import CompletedProjects from '@/views/frontend/pages/employers/project/completed-projects.vue'
import PendingProjects from '@/views/frontend/pages/employers/project/pending-projects.vue'
import CancelledProjects from '@/views/frontend/pages/employers/project/cancelled-projects.vue'
import ExpiredProjects from '@/views/frontend/pages/employers/project/expired-projects.vue'
import Favourites from '@/views/frontend/pages/employers/favourites/favourites.vue'
import CompanyProject from '@/views/frontend/pages/employers/company-project.vue'
import InvitedFavourites  from '@/views/frontend/pages/employers/favourites/invited-favourites.vue'
import Review  from '@/views/frontend/pages/employers/review.vue'
import DepositFunds  from '@/views/frontend/pages/employers/payments/deposit-funds.vue'
import ProfileSettings  from '@/views/frontend/pages/employers/settings/profile-settings.vue'
import MembershipPlans  from '@/views/frontend/pages/employers/membership/membership-plans.vue'
import Verifyidentity from '@/views/frontend/pages/employers/verifyidentity/verify-identity.vue'
import Project_Changepassword from '@/views/frontend/pages/employers/settings/project-change-password.vue'
import Deleteaccount from '@/views/frontend/pages/employers/settings/delete-account.vue'
import Developer from '@/views/frontend/pages/freelancer/developer.vue'
import Developerdetails from '@/views/frontend/pages/freelancer/developer-details.vue'
import Dashboard from '@/views/frontend/pages/employers/dashboard.vue'
import CompanyProfile from '@/views/frontend/pages/employers/company-profile.vue'
import ViewProjectDetail from '@/views/frontend/pages/employers/milestonelist/view-project-detail.vue'
import MileStones from '@/views/frontend/pages/employers/milestonelist/milestones.vue'
import Task from '@/views/frontend/pages/employers/milestonelist/tasks.vue'
import Files from '@/views/frontend/pages/employers/milestonelist/files.vue'
import ProjectPayment from '@/views/frontend/pages/employers/milestonelist/project-payment.vue'
import Completedprojectsviewdetails from '@/views/frontend/pages/employers/completedprojectlist/completed-projects-view-details.vue'
import Completedprojectsmilestones from '@/views/frontend/pages/employers/completedprojectlist/completed-projects-milestones.vue'
import Completedprojectstasks from '@/views/frontend/pages/employers/completedprojectlist/completed-projects-tasks.vue'
import Completedprojectsprojectpayment from '@/views/frontend/pages/employers/completedprojectlist/completed-projects-project-payment.vue'
import Completedprojectsfiles from '@/views/frontend/pages/employers/completedprojectlist/completed-projects-files.vue'
import Projectemployerviewproposal from '@/views/frontend/pages/employers/project/project-employer-view-proposal.vue'
import Pages from '@/views/frontend/pages/pages/pages.vue'
import About from '@/views/frontend/pages/pages/about-us/about-us.vue'
import Blank_Page from '@/views/frontend/pages/pages/blank-page.vue'
import Page_404 from '@/views/frontend/pages/pages/404-page.vue'
import register from '@/views/frontend/pages/pages/register.vue'
import Forgot_Password from '@/views/frontend/pages/pages/forgot-password.vue'
import Change_Passwords from '@/views/frontend/pages/pages/change-passwords.vue'
import Onboard_Screen from '@/views/frontend/pages/pages/onboard-screen/onboard-screen.vue'
import Onboard_Screen_Employer from '@/views/frontend/pages/pages/onboard-screen/onboard-screen-employer.vue'
import Blog from '@/views/frontend/pages/blogs/blog.vue'
import Blog_List from '@/views/frontend/pages/blogs/blog-list/blog-list.vue'
import Blog_Grid from '@/views/frontend/pages/blogs/blog-grid/blog-grid.vue'
import Blog_Details from '@/views/frontend/pages/blogs/blog-details/blog-details.vue'
import Chats from '@/views/frontend/pages/employers/chats/chats.vue'
import Freelancer_Verify_Identity from '@/views/frontend/pages/freelancer/freelancer-verify-identity.vue'
import Freelancer_Review from '@/views/frontend/pages/freelancer/freelancer-review.vue'
import Freelancer_Chats from '@/views/frontend/pages/employers/chats/chats.vue'
import Freelancer_Portfolio from '@/views/frontend/pages/freelancer/freelancer-portfolio.vue'
import Freelancer from '@/views/frontend/pages/freelancer/freelancer.vue'
import Project from '@/views/frontend/pages/freelancer/project-grid/project-grid.vue'
import Projectlist from '@/views/frontend/pages/freelancer/project-list/project-list.vue'
import Projectdetails from '@/views/frontend/pages/freelancer/project-details/project-details.vue'
import Freelancerdashboard from '@/views/frontend/pages/freelancer/dashboard/freelancer-dashboard.vue'
import Freelancer_Change_Password from '@/views/frontend/pages/freelancer/freelancer-change-password.vue'
import Freelancer_Membership from '@/views/frontend/pages/freelancer/membership/freelancer-membership.vue'
import Freelancer_Withdraw_Money from '@/views/frontend/pages/freelancer/freelancer-withdraw-money.vue'
import Freelancer_Payout from '@/views/frontend/pages/freelancer/freelancer-payout.vue'
import Freelancer_Favourites from '@/views/frontend/pages/freelancer/freelancer-favourites.vue'
import Freelancer_Invitations from '@/views/frontend/pages/freelancer/freelancer-invitations.vue'
import Freelancer_Project_Proposals from '@/views/frontend/pages/freelancer/projects/freelancer-project-proposals.vue'
import Freelancer_Ongoing_Proposals from '@/views/frontend/pages/freelancer/projects/freelancer-ongoing-proposals.vue'
import Freelancer_Completed_Projects from '@/views/frontend/pages/freelancer/projects/freelancer-completed-projects.vue'
import Freelancer_Cancelled_Projects from '@/views/frontend/pages/freelancer/projects/freelancer-cancelled-projects.vue'
import Freelancer_View_Project_Detail from '@/views/frontend/pages/freelancer/projects/freelancer-view-project-detail.vue'
import Freelancer_Milestones from '@/views/frontend/pages/freelancer/projects/freelancer-milestones.vue'
import Freelancer_Task from '@/views/frontend/pages/freelancer/projects/freelancer-task.vue'
import Freelancer_Files from '@/views/frontend/pages/freelancer/projects/freelancer-files.vue'
import Freelancer_Payment from '@/views/frontend/pages/freelancer/projects/freelancer-payment.vue'
import Freelancer_Delete_Account from '@/views/frontend/pages/freelancer/projects/freelancer-delete-account.vue'
import Freelancer_Profile_Settings from '@/views/frontend/pages/freelancer/freelancer-profile-settings/freelancer-profile-settings.vue'
import Freelancer_Developer_Profile from '@/views/frontend/pages/freelancer/developer-profile/developer-profile.vue'

import Notifications from '@/views/frontend/pages/notifications.vue'
import Faq from '@/views/frontend/pages/faq.vue'
import Privacy_Policy from '@/views/frontend/pages/privacy-policy.vue'
import Post_Project from '@/views/frontend/pages/post-project/post-project.vue'
import Term_Condition from '@/views/frontend/pages/term-condition.vue'





// New imports for new home page - AS
import Inicio_AS from '@/views/frontend/pages/trabaja_en_agv/inicio_AS.vue';
import NuestraCultura_AS from '@/views/frontend/pages/trabaja_en_agv/nuestra_cultura_AS.vue'
import YoungTalent_AS from '@/views/frontend/pages/trabaja_en_agv/young_talent_AS.vue'
import EscuelaCorporativa_AS from '@/views/frontend/pages/trabaja_en_agv/escuela_corporativa_AS.vue'
import OfertasLaborales_AS from '@/views/frontend/pages/trabaja_en_agv/ofertas_laborales_AS.vue'
import DetalleOfertaLaboral_AS from '@/views/frontend/pages/trabaja_en_agv/detalle_oferta_laboral_AS.vue'
import Login_AS from '@/views/frontend/pages/trabaja_en_agv/login_AS.vue'

const routes = [

//---------- Trabaja en Agrovision - Postulantes --------//
// {
//     path: '/',
//     name: 'inicio',
//     component: Inicio
// },
// New route for new home page - AS
{
    path: '/',
    name: 'inicio',
    component: Inicio_AS
},
{
    path: '/escuela_corporativa',
    name: 'escuela_corp',
    // component: EscuelaCorporativa -> New component for new home page
    component: EscuelaCorporativa_AS
},
{
    path: '/ofertas_laborales',
    name: 'ofertas_lab',
    // component: OfertasLaborales -> New component for new home page
    component: OfertasLaborales_AS
},
// {
//     path: '/convocatorias-vigentes', // Creado porque Google aún mantiene ese enlace en sus resultados de busqueda
//     name: 'ofertas_lab',
//     component: OfertasLaborales
// },
{
    path: '/detalle_oferta',
    name: 'detalle_oferta_lab',
    // component: DetalleOfertaLaboral -> New component for new home page
    component: DetalleOfertaLaboral_AS
},
{
    path: '/crear_cuenta',
    name: 'crear_cuenta',
    component: CrearCuenta
},
{
    path: '/crear_cuenta_2',
    name: 'crear_cuenta_2',
    component: CrearCuenta2
},
{
    path: '/young_talent',
    name: 'young_talent',
    // component: YoungTalent -> New component for new home page - AS
    component: YoungTalent_AS
},
{
    path: '/nosotros',
    name: 'nosotros',
    component: Nosotros
},
{
    path: '/nuestra_cultura',
    name: 'nuestra_cultura',
    // component: NuestraCultura -> New component for new home page - AS
    component: NuestraCultura_AS
},
{
    path: '/nuestros_colaboradores',
    name: 'nuestros_colaboradores',
    component: NuestrosColaboradores
},

{ path: '/:pathMatch(.*)*', name: 'NotFound', component: Inicio },

// Dashboard
{
    path: '/dashboard_ofertas_laborales',
    name: 'dashboard_postulante_ofertas_laborales',
    component: DashboardPostulanteOfertasLaborales
},
{
    path: '/dashboard_detalle_oferta',
    name: 'dashboard_postulante_detalle_oferta',
    component: DashboardPostulanteDetalleOferta
},
{
    path: '/postulaciones',
    name: 'postulaciones',
    component: DashboardPostulaciones
},
{
    path: '/favoritos',
    name: 'favoritos',
    component: DashboardFavoritos
},
// {
//     path: '/accesos_sistema',
//     name: 'dashboard_postulante_accesos_sistema',
//     component: DashboardPostulanteAccesosSistema
// },
{
    path: '/datos_personales',
    name: 'dashboard_postulante_datos_personales',
    component: DashboardPostulanteDatosPersonales
},
// {
//     path: '/educacion_exp_lab',
//     name: 'dashboard_postulante_educacion_exp_lab',
//     component: DashboardPostulanteEducacion
// },
// {
//     path: '/experiencia_laboral',
//     name: 'dashboard_postulante_experiencia_laboral',
//     component: DashboardPostulanteExperienciaLaboral
// },

{
    path: '/postulacion-correcta',
    name: 'postulacioncorrecta',
    component: PostulacionCorrecta
},

//-------------- TEMPLATE --------------//
{
    path: '/login',
    name: 'login',
    // component: Login -> New component for new home page - AS
    component: Login_AS //
},
{
    path: '/notification',
    name: 'notifications',
    component: Notifications
},
{
    path: '/faq',
    name: 'faq',
    component: Faq
},
{
    path: '/term-condition',
    name: 'term-condition',
    component: Term_Condition
},
{
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: Privacy_Policy
},
{
    path: '/post-project',
    name: 'post-project',
    component: Post_Project
},
// {
//     path: "/employers",
//     component: Employers,
//     children: [
//       { path: "", redirect: "/employers/manage-projects" },
//       { path: "manage-projects", component:ManageProject },
//       { path: "ongoing-projects", component:OngoingProjects },
//       { path: "completed-projects", component:CompletedProjects },
//       { path: "pending-projects", component:PendingProjects },
//       { path: "cancelled-projects", component:CancelledProjects },
//       { path: "expired-projects", component:ExpiredProjects },
//       { path: "chats", component:Chats },
//       { path: "favourites", component:Favourites },
//       { path: "company-project", component:CompanyProject },
//       { path: "invited-favourites", component:InvitedFavourites },
//       { path: "review", component:Review },
//       { path: "deposit-funds", component:DepositFunds },
//       { path: "profile-settings", component:ProfileSettings },
//       { path: "membership-plans", component:MembershipPlans},
//       { path: "verify-identity", component:Verifyidentity},
//       { path: "change-password", component:Project_Changepassword},
//       { path: "delete-account", component:Deleteaccount},
//       { path: "developer", component:Developer},
//       { path: "developer-details", component:Developerdetails},
//       { path: "dashboard", component:Dashboard},
//       { path: "company-profile", component:CompanyProfile},
//       { path: "view-project-detail", component:ViewProjectDetail},
//       { path: "milestones", component:MileStones},
//       { path: "tasks", component:Task},
//       { path: "files", component:Files},
//       { path: "project-payment", component:ProjectPayment},
//       { path: "completed-projects-view-details", component:Completedprojectsviewdetails},
//       { path: "completed-projects-milestones", component:Completedprojectsmilestones},
//       { path: "completed-projects-tasks", component:Completedprojectstasks},
//       { path: "completed-projects-files", component:Completedprojectsfiles},
//       { path: "completed-projects-project-payment", component: Completedprojectsprojectpayment},
//       { path: "project-employer-view-proposal", component:Projectemployerviewproposal},
//     ],
// },
// {
//     path: "/blog",
//     component: Blog,
//     children: [
//       { path: "", redirect: "/blog/blog-list" },
//       { path: "blog-list", component:Blog_List },
//       { path: "blog-grid", component:Blog_Grid },
//       { path: "blog-details", component:Blog_Details },
//     ],
// },
{
    path: "/pages",
    component: Pages,
    children: [
      { path: "", redirect: "/pages/about" },
      { path: "about", component:About },
      { path: "blank-page", component:Blank_Page },
      { path: "404-page", component:Page_404 },
      { path: "onboard-screen", component:Onboard_Screen },
      { path: "onboard-screen-employer", component:Onboard_Screen_Employer },
    ],
},
// {
//     path: "/freelancer",
//     component: Freelancer,
//     children: [
//       { path: "", redirect: "/freelancer/project" },
//       { path: "freelancer-verify-identity", component:Freelancer_Verify_Identity },
//       { path: "freelancer-review", component:Freelancer_Review },
//       { path: "freelancer-chats", component:Freelancer_Chats },
//       { path: "freelancer-portfolio", component:Freelancer_Portfolio },
//       { path: "project", component:Project },
//       { path: "project-list", component:Projectlist },
//       { path: "project-details", component:Projectdetails },
//       { path: "freelancer-dashboard", component:Freelancerdashboard },
//       { path: "freelancer-change-password", component:Freelancer_Change_Password },
//       { path: "freelancer-membership", component:Freelancer_Membership },
//       { path: "freelancer-withdraw-money", component:Freelancer_Withdraw_Money },
//       { path: "freelancer-payout", component:Freelancer_Payout },
//       { path: "freelancer-favourites", component:Freelancer_Favourites },
//       { path: "freelancer-invitations", component:Freelancer_Invitations },
//       { path: "freelancer-project-proposals", component:Freelancer_Project_Proposals },
//       { path: "freelancer-ongoing-projects", component:Freelancer_Ongoing_Proposals },
//       { path: "freelancer-completed-projects", component:Freelancer_Completed_Projects },
//       { path: "freelancer-cancelled-projects", component:Freelancer_Cancelled_Projects },
//       { path: "freelancer-view-project-detail", component:Freelancer_View_Project_Detail},
//       { path: "freelancer-milestones", component:Freelancer_Milestones},
//       { path: "freelancer-task", component:Freelancer_Task},
//       { path: "freelancer-files", component:Freelancer_Files},
//       { path: "freelancer-payment", component:Freelancer_Payment},
//       { path: "freelancer-delete-account", component:Freelancer_Delete_Account},
//       { path: "freelancer-profile-settings", component:Freelancer_Profile_Settings},
//       { path: "developer-profile", component:Freelancer_Developer_Profile},
//     ],
// },
{
    path: '/forgot-password',
    name: 'forgot-password',
    component: Forgot_Password
},
{
    path: '/change-passwords',
    name: 'change-passwords',
    component: Change_Passwords
},
{
    path: '/register',
    name: 'register',
    component: register
},
{
    path: "/home",
    component: Home,
    children: [
      { path: "", redirect: "/home/home" },
      { path: "home", component:Index },
      { path: "home2", component:Indextwo },
      { path: "home3", component:Indexthree },
      { path: "home4", component:IndexFour },
      { path: "home5", component:IndexFive },
    ],
},



// ********* MÓDULO NO DISPONIBLE (Rutas administrativas e inactivas) *********
{
    path: "/no-disponible",
    name: "no-disponible",
    component: NoDisponible,
},
{
    path: "/admin/login",
    name: "LoginAdmin",
    component: NoDisponible,
},
{
    path: "/admin",
    redirect: "/no-disponible",
},
{
    path: "/admin/:pathMatch(.*)*",
    name: "admin-no-disponible",
    component: NoDisponible,
},
]

export const router = createRouter({
    history: createWebHistory('/'),
    linkActiveClass: 'active',
    routes,
}); 

router.beforeEach((to, from, next) => {
    // Scroll to the top of the page
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // console.log("URL que se redirecciona", to);
    // let root = to.path.split('/');
    // console.log("contenido de la URL", root);
    // if (root[1] === 'admin' && root[2] !== 'login') {
    //     console.log("información de la session", localStorage.getItem("userData"));
    // }

    // Continue with the navigation
    next();
});


// router.beforeEach((to, from, next) => {
//     const publicPages = ['login', 'home'];
//     const authRequired = !publicPages.includes(to.name);
//     const loggedIn = JSON.parse(localStorage.getItem('userData'));

//     if (authRequired && (!loggedIn )) {
//         return next({ name: 'login' });
//     }

//     next();
// });

// export default router;